window.sumD2incart = 0;
window.sumD4incart = 0;

document.getElementById("checkout").addEventListener("click", function(e) {
    var cartItems = JSON.parse(sessionStorage.getItem('cartItems')); 
});

function handleDeviceIdsChange() {  
    var errorElement = document.querySelector('.serialId-error');  
  
    var proceedButton = document.getElementById("modal_checkout");  
  
    var deviceGroups = document.querySelectorAll('.device-group');  
    var countD2 = 0;  
    var countD4 = 0;  
  
    deviceGroups.forEach(function(group) {  
        if (group.id.includes("D-2")) {  
            countD2 += group.querySelectorAll('.serialId_checkbox:checked').length;  
        } else if (group.id.includes("D-4")) {  
            countD4 += group.querySelectorAll('.serialId_checkbox:checked').length;  
        }  
    });  
    // console.log("in serial file countD2", countD2);
    // console.log("in serial file countD4", countD4);
    if (countD2 === window.sumD2incart && countD4 === window.sumD4incart) {  
        errorElement.style.display = 'none';  
        proceedButton.disabled = false;  
    } else {  
        errorElement.style.display = 'block';  
        proceedButton.disabled = true;  
    }  
  
    var checkoutButton = document.getElementById("checkout");  
    checkoutButton.disabled = false;  
} 

document.getElementById("checkout").addEventListener("click", function(e) {
    var checkoutButton = document.getElementById("checkout");
    checkoutButton.disabled = false;
    // console.log("In the serialID file");
    var errorElement = document.querySelector('.serialId-error');

    // Get the 'Proceed to Checkout' button  
    var proceedButton = document.getElementById("modal_checkout");

    // Get all device-group divs  
    var deviceGroups = document.querySelectorAll('.device-group');

    // Initialize counts  
    var countD2 = 0;
    var countD4 = 0;

    // Loop over each device-group  
    deviceGroups.forEach(function(group) {
        if (group.id.includes("D-2")) {
            // console.log("In device-group D2");
            countD2 += group.querySelectorAll('.serialId_checkbox:checked').length;
            // console.log("countD2", countD2);
        } else if (group.id.includes("D-4")) {
            // console.log("In device-group D4");
            countD4 += group.querySelectorAll('.serialId_checkbox:checked').length;
            // console.log("countD4", countD4);
        }
    });

    // Compare the counts with sumD2incart and sumD4incart  
    if (countD2 === window.sumD2incart && countD4 === window.sumD4incart) {
        errorElement.style.display = 'none';
        proceedButton.disabled = false;
    } else {
        errorElement.style.display = 'block';
        proceedButton.disabled = true;
    }

    // console.log("proceedButton.disabled", proceedButton.disabled);
    // console.log("countD2", countD2);
    // console.log("countD4", countD4);
    // console.log("sumD2incart", window.sumD2incart);
    // console.log("sumD4incart", window.sumD4incart);
    var checkoutButton = document.getElementById("checkout");
    checkoutButton.disabled = false;
  handleDeviceIdsChange();
  setTimeout(handleDeviceIdsChange, 4000);  

});

 
  
document.getElementById("device-ids").addEventListener('change', handleDeviceIdsChange);  


document.getElementById('modal_checkout').addEventListener('click', function() {
    // Get all elements with class "device-group"
    var deviceGroups = document.getElementsByClassName("device-group");

    var checkedItems = {};

    // Loop through all elements with class "device-group"
    for (var i = 0; i < deviceGroups.length; i++) {
        var deviceGroup = deviceGroups[i];
        var deviceGroupId = deviceGroup.id; // This is the key
        var checkboxes = deviceGroup.getElementsByClassName("serialId_checkbox");
        checkedItems[deviceGroupId] = [];

        // Loop through all checkboxes inside the current deviceGroup
        for (var j = 0; j < checkboxes.length; j++) {
            var checkbox = checkboxes[j];

            // If checkbox is checked, add its id to the array
            if (checkbox.checked) {
                checkedItems[deviceGroupId].push(checkbox.id);
            }
        }
    }

    // Store the data into sessionStorage
    sessionStorage.setItem('checkedItems', JSON.stringify(checkedItems));

    var errorElement = document.querySelector('.serialId-error');
    // Get cartItems from session storage and parse it back into an array  
      

    // console.log("Enter the loop");
    // Get the 'Proceed to Checkout' button  
    var proceedButton = document.getElementById("modal_checkout");
    // console.log("Above the loop");
    // Check if the clicked element is a checkbox    
    var deviceGroups = document.querySelectorAll('.device-group');
    var countD2 = 0;
    var countD4 = 0;

    deviceGroups.forEach(function(group) {
        if (group.id.includes("D-2")) {
            // console.log("In device-group D2");
            countD2 += group.querySelectorAll('.serialId_checkbox:checked').length;
            // console.log("countD2", countD2);
        } else if (group.id.includes("D-4")) {
            // console.log("In device-group D4");
            countD4 += group.querySelectorAll('.serialId_checkbox:checked').length;
            // console.log("countD4", countD4);
        }
    });

    if (countD2 === window.sumD2incart && countD4 === window.sumD4incart) {
        errorElement.style.display = 'none';
        proceedButton.disabled = false;
    } else {
        errorElement.style.display = 'block';
        proceedButton.disabled = true;
    }

    // console.log("proceedButton.disabled -2", proceedButton.disabled);
    // console.log("countD2-2", countD2);
    // console.log("countD4-2", countD4);
    // console.log("sumD2incart-2", window.sumD2incart);
    // console.log("sumD4incart-2", window.sumD4incart);
    var checkoutButton = document.getElementById("checkout");
    checkoutButton.disabled = false;
});